














































import Vue from 'vue'
import BucketSelector from '@/components/BucketSelector.vue'
import Button from '@/types/components/Button.interface'
import { mapGetters } from 'vuex'
import multiselectMixin from '@/mixins/multiselect-mixin'
import UserSelector from '@/components/UserSelector.vue'
export default Vue.extend({
    name: 'ChannelAssignmentForm',
    mixins: [multiselectMixin],
    components: { BucketSelector, UserSelector },
    props: {
        channelIds: {
            type: Array,
            required: true
        },
        currentGroup: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            //  The v-model for the menu loading spinner
            loading: false,
            //  The width of the menu component
            maxWidth: '330px',
            //  The v-model for our menu
            menu: false,
            //  Determines if we will remove from a view after adding
            remove: false,
            // The current step we are in the v-stepper
            step: 1
        }
    },
    computed: {
        ...mapGetters(['users']),
        broadcastsEnabled(): boolean {
            return this.$store.getters.getEnabled('broadcast')
        },
        cards(): Button[] {
            //  Assemble the default cards
            const cards: Button[] = [
                {
                    text: 'Assign to teammate',
                    icon: 'bi-person-circle',
                    callback: () => this.setStep(2)
                },
                {
                    text: 'Mark as New',
                    icon: 'bi-exclamation-circle-fill',
                    callback: () => this.markAsNew()
                },
                {
                    text: 'Add to view',
                    icon: 'bi-folder-plus',
                    callback: () => this.setStep(3)
                },
                {
                    text: 'Send Message',
                    icon: 'bi-megaphone-fill',
                    callback: () => this.startBroadcast(this.channelIds)
                },
                {
                    text: 'Add to view and remove from current',
                    icon: 'bi-folder-symlink-fill',
                    hidden: !this.currentGroup,
                    callback: () => this.addAndRemove()
                },
                {
                    text: 'Remove from view',
                    icon: 'bi-folder-x',
                    hidden: !this.currentGroup,
                    callback: () => this.removeFromBucket()
                }
            ]

            //  Filter out the hidden
            return cards.filter((x: Button) => !x.hidden)
        }
    },
    methods: {
        addAndRemove(): void {
            //  Set our remove boolean to true
            this.remove = true

            //  Set our step to 3
            this.setStep(3)
        },
        iconClick(): void {
            //  If we're on step 1, close the menu
            if (this.step === 1) this.menu = false
            //  Else, set the step to 1
            else this.setStep(1)
        }
    },
    watch: {
        step(val: number): void {
            //  If the value is ever 1, set remove to false
            if (val === 1) this.remove = false
        }
    }
})
